/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from './enums';
import {enumType} from '../common/enumType';

export const daysOfWeek = enumType({
   Sun: 'SUNDAY',
   Mon: 'MONDAY',
   Tue: 'TUESDAY',
   Wed: 'WEDNESDAY',
   Thu: 'THURSDAY',
   Fri: 'FRIDAY',
   Sat: 'SATURDAY',
});

export const DayOfWeek = yup.string().oneOf(enums.DayOfWeek.keys);
export type IDayOfWeek = yup.InferType<typeof DayOfWeek>;
